'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Component = require('vue-class-component');
var Component__default = _interopDefault(Component);

function debounce(func, waitMilliseconds = 100, isImmediate = false) {
  let timeoutId;
  return function(...args) {
    const context = this;
    const doLater = () => {
      timeoutId = void 0;
      if (!isImmediate) {
        func.apply(context, args);
      }
    };
    const shouldCallNow = isImmediate && timeoutId === void 0;
    if (timeoutId !== void 0) {
      window.clearTimeout(timeoutId);
    }
    timeoutId = window.setTimeout(doLater, waitMilliseconds);
    if (shouldCallNow) {
      func.apply(context, args);
    }
  };
}
const Debounce = (delayMs, isImmediate = false) => Component.createDecorator((options, key) => {
  if (!options.methods) {
    options.methods = {};
  }
  const functionToDebounce = options.methods[key];
  if (functionToDebounce && delayMs > 0) {
    options.methods[key] = debounce(functionToDebounce, delayMs, isImmediate);
  }
});

exports.Debounce = Debounce;
exports.debounce = debounce;
